import { axiosObject } from "../config";

export default function getPropertiesFacets(payload: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/properties/_read";
    let data = {
      apiConfig: {
        includeRelations: [],
        includeMutations: [],
        includeFacets: true,
      },
      limitBy: {
        per_page: 0,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "asc" }],
      filterBy: payload,
    };
    axiosObject
      .post(uri, data)
      .then((response) => {
        resolve(response.data.facets);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
